import _extends from '@babel/runtime/helpers/esm/extends'
import { createNamespace } from 'vant/lib/utils'
import skuHelper from 'vant/lib/sku/utils/skuHelper'

var _createNamespace = createNamespace('sku-row-item'); var  createComponent = _createNamespace[0]

export default createComponent({
    props: {
        skuValue: Object,
        skuKeyStr: String,
        skuEventBus: Object,
        selectedSku: Object,
        skuList: {
            type: Array,
            default: function _default () {
                return []
            }
        }
    },
    data () {
        return {
            _skuList: []
        }
    },
    watch: {
        skuList: {
            handler: function (newValue, oldValue) {
                // 若是秒杀则取秒杀库存做为库存判断是否允许选择规格
                this._skuList = newValue.reduce((total, item) => {
                    // 是秒杀规格 && 正处于秒杀活动中 && 秒杀库存大于零
                    if (Number(item.is_seckill) === 1 && Number(item.seckill_status) === 2 && item.seckill_stock > 0) {
                        item.stock_num = item.seckill_stock
                    }
                    total.push(item)
                    return total
                }, [])
            },
            immediate: true
        }
    },
    computed: {
        choosable: function choosable () {
            return skuHelper.isSkuChoosable(this._skuList, this.selectedSku, {
                key: this.skuKeyStr,
                valueId: this.skuValue.id
            })
            // return skuHelper.isSkuChoosable(this.skuList, this.selectedSku, {
            //     key: this.skuKeyStr,
            //     valueId: this.skuValue.id
            // })
        }
    },
    methods: {
        onSelect: function onSelect () {
            if (this.choosable) {
                this.skuEventBus.$emit('sku:select', _extends({}, this.skuValue, {
                    skuKeyStr: this.skuKeyStr
                }))
            }
        }
    },
    render: function render () {
        var h = arguments[0]
        var choosed = this.skuValue.id === this.selectedSku[this.skuKeyStr] // const imgUrl = this.skuValue.imgUrl || this.skuValue.img_url;

        return h('span', {
            'class': ['van-sku-row__tag', {
                'van-sku-row__tag--active': choosed,
                'van-hairline--top': choosed,
                'van-sku-row__tag--disabled': !this.choosable
            }],
            'on': {
                'click': this.onSelect
            }
        }, [this.skuValue.name])
    }
})
